import { useState } from "react";
import Modal from "@/components/Modal";
import { Button } from "@/components/ui/button";
import { useCreateStockCountMutation } from "@/redux/services/inventory/stockCount.api";
import toast from "react-hot-toast";

interface StartStockCountModalProps {
  isOpen: boolean;
  onClose: () => void;
  restaurantId: string;
  onStarted: (uuid: string) => void;
}

const StartStockCountModal = ({
  isOpen,
  onClose,
  restaurantId,
  onStarted,
}: StartStockCountModalProps) => {
  const [notes, setNotes] = useState("");
  const [createStockCount, { isLoading }] = useCreateStockCountMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const res = await createStockCount({
      restaurantId,
      data: notes.trim() ? { notes: notes.trim() } : {},
    });
    if ("data" in res && res.data) {
      toast.success("Inventaire démarré");
      setNotes("");
      onStarted(res.data.id);
    } else {
      toast.error("Erreur lors de la création");
    }
  };

  const handleClose = () => {
    setNotes("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Démarrer un inventaire">
      <form onSubmit={handleSubmit} className="space-y-4">
        <p className="text-xs text-muted-foreground">
          Un contrôle de stock sera créé avec une ligne par ingrédient, basée
          sur le stock théorique actuel. Vous pourrez saisir les quantités
          comptées immédiatement après.
        </p>
        <div>
          <label
            htmlFor="start-count-notes"
            className="block text-sm font-medium text-card-foreground mb-1"
          >
            Notes (optionnel)
          </label>
          <textarea
            id="start-count-notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={3}
            className="w-full border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
            placeholder="Ex: Inventaire mensuel mars, Comptage après livraison..."
          />
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="outline" onClick={handleClose}>
            Annuler
          </Button>
          <Button type="submit" isLoading={isLoading}>
            Démarrer
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default StartStockCountModal;
